module.exports = __webpack_public_path__ + "static/media/C12.71271b39.png";